import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "../axios/axiosUmbraco";
import { useTranslate } from "../components/TranslationText";
import Loader from "../components/Loader";
import ActionButton from "../components/ActionButton";
import { useLocation } from "react-router";
import { formatDateTimeToString } from "../helper/formatDateTimeToString";
import ImagesSlider from "../components/ImagesSlider";
import { Link } from "react-router-dom";
import { convertYouTubeURL, getThumbnailUrlFromEmbedLink } from "../helper/getThumbnailUrlFromEmbedLink";
import Lightbox from "react-18-image-lightbox";
import { whiteCard } from "../common/cssclasses";
import { updateHeadTags } from "../helper/updateHeadTags";

const MediaBaseURL = process.env.REACT_APP_UMBRACO_MEDIA_BASE_URL;

export default function SinglePost() {
    const BaseURL = process.env.REACT_APP_BASE_URL;
    const { currentLanguage } = useSelector(
        (state) => state.studBookSlice
    );
    const [post, setPost] = useState([]);
    const { translate } = useTranslate();

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    const id = searchParams.has("id")
        ? searchParams.get("id")
        : '';
    const urlTitle = searchParams.has("title") ? searchParams.get("title") : "";

    const [formattedImages, setFormattedImages] = useState([]);
    const [images, setImages] = useState([]);
    const [imageslightbox, setImageslightbox] = useState([]);



    function getCurrentLanguageUmbraco() {
        // Replace this with your logic to retrieve the current language
        // For example, you can retrieve it from localStorage or from a state variable
        const lang = localStorage.getItem("eahsLang") ?? "en";
        if (lang == "en") return 'en-US';
        else return 'ar-AE'; // Defaulting to English for demonstration
    }

    function reformatImages(images, isLightBox) {
        if (isLightBox !== true) {
            return (
                images.map((image, index) => ({
                    src: image.isvideo ? convertYouTubeURL(getThumbnailUrlFromEmbedLink(image.src)) : getThumbnailUrlFromEmbedLink(image.src),
                    width: image.width,
                    height: image.height,
                    isvideo: image.isvideo,
                    tags: image.isvideo ? [
                        { value: <i className=" fa-solid fa-play" style={{ fontSize: 18 }}></i> },
                    ] : [],
                }))
            );
        } else {
            return (
                images.map((image, index) => ({
                    src: convertYouTubeURL(image.src),
                    width: image.width,
                    height: image.height,
                    isvideo: image.isvideo,
                    tags: image.isvideo ? [
                        { value: <i className=" fa-solid fa-play" style={{ fontSize: 18 }}></i> },
                    ] : [],
                }))
            );
        }
    }

    useEffect(() => {
        async function getdata() {
            const umbraco = await axios.get(`/umbraco/delivery/api/v1/content/item?id=${id}`, {
                headers: {
                    "accept-language": getCurrentLanguageUmbraco(),

                }
            })
            // console.log('Umbraco News are umbraco is', umbraco.data);
            const formattedData = umbraco.data?.map((item) => ({
                Item_Title: item?.properties?.Item_Title || urlTitle,
                Item_Date: formatDateTimeToString(item?.properties?.Item_Date, getCurrentLanguageUmbraco()) ?? "",
                Item_ShortDescription: item?.properties?.Item_ShortDescription ?? '',
                Item_Body: item?.properties?.Item_Body?.markup ?? '',
                Item_CoverImage: item.properties?.Item_CoverImage ? item.properties?.Item_CoverImage : [],
                createdBy: item?.properties?.createdBy ?? "",
                metaName: item?.properties?.metaName,
                metaKeywords: item?.properties?.metaKeywords,
                metaDescription: item?.properties?.metaDescription,
            }));

            if (formattedData.length > 0) {
                updateHeadTags({
                    keywords: formattedData[0]?.metaKeywords,
                    description: formattedData[0]?.metaDescription,
                    title: formattedData[0]?.metaName,
                })
            }

            setPost(formattedData);
            if (formattedData.length > 0) {
                const images = formattedData[0]?.Item_CoverImage?.map((image, index) => ({
                    src: MediaBaseURL + image.url,
                    width: 320,
                    isvideo: false,
                    height: 174,
                    caption: image.name,
                }));


                setFormattedImages(images);
                setImages(reformatImages(images, false));
                setImageslightbox(reformatImages(images, true));
            }
        }
        getdata();

    }, [currentLanguage])


    const [index, setIndex] = useState(-1);

    const currentImage = images[index];
    const nextIndex = (index + 1) % images.length;
    const nextImage = images[nextIndex] || currentImage;
    const prevIndex = (index + images.length - 1) % images.length;
    const prevImage = images[prevIndex] || currentImage;

    const handleClick = (index) => setIndex(index);
    const handleClose = () => setIndex(-1);
    const handleMovePrev = () => setIndex(prevIndex);
    const handleMoveNext = () => setIndex(nextIndex);

    function getVideoFrame(index) {
        return (<iframe width="90%" height="90%" src={imageslightbox[index].src} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>);
    }

    return (
        <>

            {post.length === 0 &&
                <Loader />
            }
            {post.length > 0 &&
                post.map((post) => (
                    <>
                        <div className='row rtl'>
                            <div className='col-lg-12 col-md-12 col-sm-12'>
                                <div className={whiteCard}>
                                    <h2 className='fw-bold '>
                                        {post.Item_Title}
                                    </h2>
                                    <div className="row mb-main  rtl">
                                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-6 mb-1   ">
                                            <i className="fa fa-calendar C89C66">
                                            </i>
                                            <span> {post.Item_Date}</span>
                                        </div>
                                    </div>
                                    <div className="mainSpacer  mb-main" />

                                    {post?.Item_CoverImage.length > 0 &&
                                        <div className="row rtl">
                                            {post?.Item_CoverImage.map((item, index) => (
                                                <div key={index} className="col-auto mb-main">
                                                    <div onClick={() => handleClick(index)} className="d-block overflow-hidden border-15" style={{ cursor: 'pointer', maxWidth: '100%' }}>
                                                        <img className='border-15' src={`${MediaBaseURL}${item?.url}`} style={{ height: 200, width: 'auto', maxWidth: '100%', objectFit: 'contain', display: 'block', cursor: 'pointer' }} alt={post.Item_Title} />
                                                    </div>

                                                </div>
                                            ))}
                                        </div>
                                    }
                                    <div className="mainSpacer mb-main" />
                                    <div dangerouslySetInnerHTML={{ __html: post.Item_Body }} className="noMarginBottomForP" />

                                </div>

                            </div>



                        </div>
                    </>
                ))
            }
            {!!currentImage && (
                /* @ts-ignore */
                <Lightbox
                    mainSrc={imageslightbox[index].src}
                    nextSrc={imageslightbox[(index + 1) % imageslightbox.length].src}
                    prevSrc={imageslightbox[(index + imageslightbox.length - 1) % imageslightbox.length].src}
                    onCloseRequest={handleClose}
                    onMovePrevRequest={() =>
                        setIndex((index + imageslightbox.length - 1) % imageslightbox.length)
                    }
                    onMoveNextRequest={() =>
                        setIndex((index + 1) % imageslightbox.length)
                    }
                    wrapperClassName='ltr'
                    imageLoadErrorMessage={getVideoFrame(index)}
                />
            )}
        </>

    )
}
